import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ChangeDetectionStrategy,
} from '@angular/core';
import { GridApi } from 'ag-grid-community';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class GridToolComponent implements OnChanges {
    @Input() gridApi: GridApi | undefined;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['gridApi']) {
            this.gridApi = changes['gridApi'].currentValue;
        }
    }
}
